import { render, staticRenderFns } from "./Magiclink.vue?vue&type=template&id=d2b784f0&"
import script from "./Magiclink.vue?vue&type=script&lang=js&"
export * from "./Magiclink.vue?vue&type=script&lang=js&"
import style0 from "./Magiclink.vue?vue&type=style&index=0&id=d2b784f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports